import { Component, OnInit, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { IDealerByLocation } from '@core/interface';

@Component({
  selector: 'agenda-customer-ui-card-opening-hours',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './card-opening-hours.component.html',
  styleUrls: ['./card-opening-hours.component.scss'],
  providers: [TranslateService],
})
export class CardOpeningHoursComponent implements OnInit {
  dealer = input.required<IDealerByLocation>(); ;
  isDealerOpeningHoursValid = false;

  ngOnInit() {
    this.isDealerOpeningHoursValid = this.#checkDealerOpeningHours(this.dealer());
  }

  #checkDealerOpeningHours = (dealer: IDealerByLocation): boolean => !!(dealer.lowestTimeWeek && dealer.highestTimeWeek && (dealer.lowestTimeWeek !== '' || dealer.lowestTimeWeekend !== ''));
}
